//#region src/compat/util/stubString.ts
function stubString() {
	return "";
}
//#endregion
export { stubString };
